<template>
	<table>
		<thead>
			<tr class="s-font-medium">
				<td class="s-py-1">{{ computedFile.name }}</td>
				<td v-if="item.type === 'file'" class="py-1">
					{{ $t("core.privacyLevel") }}
				</td>
				<td v-if="item.type === 'file'" class="s-py-1">{{ $t("core.size") }}</td>
				<td v-if="item.type === 'file'" class="s-py-1">{{ $t("core.modified") }}</td>
			</tr>
		</thead>
		<tbody>
			<tr>
				<td class="s-py-1">{{ computedFile.type }}</td>
				<td v-if="item.type === 'file'" class="s-py-1">
					{{ computedFile.privacy }}
				</td>
				<td v-if="item.type === 'file'" class="s-py-1">
					{{ computedFile.size }}
				</td>
				<td v-if="item.type === 'file'" class="s-py-1">
					{{ computedFile.modified }}
				</td>
			</tr>
		</tbody>
	</table>
</template>

<script>
import dayjs from "dayjs"

export default {
	props: {
		item: {
			type: [Object, null],
			default: null
		}
	},
	data() {
		return {}
	},
	computed: {
		computedFile() {
			const file = {}
			if (this.item.type === "folder") {
				file.name = this.item.name
				file.type = this.$t("core.folder")
			} else {
				const name = this.item.name.split(".")
				const ext = name.splice(-1, 1)
				file.name = name.join(".")
				file.type = `${ext} ${this.$t("core.file")}`
				file.privacy = this.item.isPublic ? this.$t("core.public") : this.$t("core.private")
				file.size = this.formatBytes(this.item.size)
				file.modified = dayjs(this.item.lastModifiedAt).format("DD/MM/YYYY HH:mm:ss")
			}
			return file
		}
	},
	methods: {
		formatBytes(bytes) {
			if (bytes === 0) return "0 Bytes"
			const k = 1024
			const sizes = ["B", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"]
			const i = Math.floor(Math.log(bytes) / Math.log(k))
			return parseFloat((bytes / k ** i).toFixed(2)) + " " + sizes[i]
		}
	}
}
</script>
